// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"4908e1ac","227":"cd4d5d0b","252":"2e33f5c8","453":"b2188b53","809":"f0ae9a96"}[chunkId] + ".chunk.js";
};